import {SET_PATIENTACCOUNT_SELECTION_DATA} from '.';
import {
  SetSelectedPatientAccountingCheckBoxPayloadParams,
  SetSelectedPatientAccountingCheckBoxAction
} from '../mappers/SelectedPatientAccountCheckBoxTypesMapper';

export const setSelectedPatientAccountingCheckBox = (
  dispatch: (action: SetSelectedPatientAccountingCheckBoxAction) => void,
  params: SetSelectedPatientAccountingCheckBoxPayloadParams
): void => {
  dispatch({
    type: SET_PATIENTACCOUNT_SELECTION_DATA,
    payload: params
  });
};
